module.exports = __webpack_public_path__ + "img/juntas2.0202c357.jpg";